import React, { createContext, useContext, useState } from 'react'

type GoogleSignupData = {
  email: string
  firstName?: string
  lastName?: string
  idToken: string
}

type SignupContextValue = {
  googleSignupData?: GoogleSignupData
  setGoogleSignupData: (data?: GoogleSignupData) => void
  clearGoogleSignupData: () => void
}

const SignupContext = createContext<SignupContextValue | undefined>(undefined)

export const SignupProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [googleSignupData, setGoogleSignupData] = useState<
    GoogleSignupData | undefined
  >()

  const clearGoogleSignupData = () => setGoogleSignupData(undefined)

  return (
    <SignupContext.Provider
      value={{ googleSignupData, setGoogleSignupData, clearGoogleSignupData }}
    >
      {children}
    </SignupContext.Provider>
  )
}

export const useSignupContext = () => {
  const ctx = useContext(SignupContext)
  if (!ctx) {
    throw new Error('useSignupContext must be used within SignupProvider')
  }
  return ctx
}
